import { FC } from 'react'

import { useAppSelector } from 'src/redux/hooks'
import DropdownMenuItem from '../../../atoms/DropdownMenuItem'
import SendIcon from '../../../atoms/Icons/SendIcon'
import { usePageHeaderContext } from '../../PageHeader/PageHeaderProvider'

const SendDashboardMenuItem: FC = () => {
  const isLoadingDone = useAppSelector(s => s.root.loadingComponents.every(c => !c.loading))
  const { setIsExportSchedulingOpen } = usePageHeaderContext()

  return (
    <DropdownMenuItem
      icon={<SendIcon className="text-hit-gray" />}
      label="Send"
      data-testid="header-dashboard-menu-send"
      onClick={() => setIsExportSchedulingOpen(true)}
      disabled={!isLoadingDone}
    />
  )
}

export default SendDashboardMenuItem
